<div [formGroup]="group" class="form-field__selection__label-wrap">
  <cwc-input
    [label]="config.label | translate"
    [formControlName]="oneClickPreviewField.PurchaseOrder"
    [rtl]="rtl"
    [required]="required"
    [placeholder]="placeholder | translate"
    [status]="control.invalid && control.touched ? 'error' : 'regular'"
    [statusMessage]="control.invalid && control.touched ? (errorMessage | translate) : ''"
    designVersion="v2"
  ></cwc-input>
</div>
